import { render } from "./QuickOrders.vue?vue&type=template&id=688a85eb&scoped=true"
import script from "./QuickOrders.vue?vue&type=script&lang=js"
export * from "./QuickOrders.vue?vue&type=script&lang=js"

import "./QuickOrders.vue?vue&type=style&index=0&id=688a85eb&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/spark_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-688a85eb"]])

export default __exports__